import { FC, useState, useCallback, useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { Button } from '@storybook';
import { IClientEmail } from 'views/email-client/stores';
import { ComplexEmailClientState, EditingClientState } from 'views/email-client/stores/states';
import { ClientItem } from './ClientItem';

interface MainViewProps {
	emailClientsList: IClientEmail[];
	handleClick: () => void;
}

export const MainView: FC<MainViewProps> = ({
	emailClientsList,
	handleClick,
}) => {
	const [openDrop, setOpenDrop] = useState(false);
	
	// Recoil state
	const [editingClient, setEditingClient] = useRecoilState(EditingClientState);
	const complexEmailClient = useRecoilValue(ComplexEmailClientState);
	const resetComplexEmailClient = useResetRecoilState(ComplexEmailClientState);

	useEffect(() => {
		if (emailClientsList.length > 0) {
			const activeClient = emailClientsList.find(client => client.isActive);
			if (activeClient) {
				setEditingClient(activeClient);
			}
		}
	}, [complexEmailClient, emailClientsList, setEditingClient]);

	const handleToggleDropdown = useCallback(() => {
		setOpenDrop(prev => !prev);
	}, []);

	const handleClientSelection = useCallback((client: IClientEmail) => {
		// Store the selected client in the recoil state
		resetComplexEmailClient();	
		setEditingClient(client);
		setOpenDrop(false);
	}, [resetComplexEmailClient, setEditingClient]);

	const selectedComplexEmailClient = emailClientsList.find(client => client._id === complexEmailClient);
	const defaultClient = emailClientsList.find(client => client.isActive);
	const selectedClient = selectedComplexEmailClient|| editingClient || defaultClient;
	const otherClients = emailClientsList.filter(
		client => client._id !== selectedClient?._id
	);

	if (!defaultClient) {
		return null;
	}

	return (
		<>
			<div className="connected-client_header-wrapper">
				<p className="header-title">Current Email Client</p>
				<div className="connected-client_header-action">
					{otherClients.length > 0 && <Button
						handleClick={handleToggleDropdown}
						label={'Change email client'}
						type="button__outline btn-change-email-client"
					/>}
					<Button
						prefixIcon="ri-add-line"
						handleClick={handleClick}
						label={'Add email client'}
						type="button__filled button__filled--primary btn-add-client"
					/>
				</div>
			</div>
			
			<ClientItem client={selectedClient || defaultClient} />
			
			{openDrop && otherClients.length > 0 && (
				<div className="connected-client_other-clients">
					{otherClients.map(client => (
						<ClientItem
							key={client._id}
							client={client}
							onClick={() => handleClientSelection(client)}
						/>
					))}
				</div>
			)}
		</>
	);
}; 